import { useState, useEffect } from 'react';
import { studentAPI } from '../../utils/api';

const StreakCalendar = () => {
  const [data, setData] = useState(null);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const res = await studentAPI.getStreakCalendar();
      setData(res.data.data);
    } catch {}
  };

  if (!data) return null;

  // Generate last 52 weeks
  const weeks = [];
  const today = new Date();
  const startDate = new Date(today);
  startDate.setDate(startDate.getDate() - 364);

  for (let w = 0; w < 52; w++) {
    const week = [];
    for (let d = 0; d < 7; d++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + (w * 7) + d);
      const key = date.toISOString().split('T')[0];
      const activity = data.heatmap[key];
      week.push({ date: key, level: activity ? activity.level : 0, topics: activity?.topics || 0 });
    }
    weeks.push(week);
  }

  const colors = ['#EDE9FF', '#C4B5FD', '#8B5CF6', '#6D28D9', '#4C1D95'];

  return (
    <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <div>
          <div style={{ fontSize: '13px', fontWeight: 800 }}>Study Activity</div>
          <div style={{ fontSize: '11px', color: '#64748B', marginTop: '2px' }}>{data.total_days} days studied · {data.current_streak} day streak</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '10px', color: '#94A3B8' }}>
          Less
          {colors.map((c, i) => <div key={i} style={{ width: '10px', height: '10px', borderRadius: '2px', background: c }}></div>)}
          More
        </div>
      </div>
      <div style={{ display: 'flex', gap: '3px', overflowX: 'auto' }}>
        {weeks.map((week, wi) => (
          <div key={wi} style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
            {week.map((day, di) => (
              <div key={di} title={day.date + (day.topics > 0 ? ` · ${day.topics} topics` : '')}
                style={{ width: '11px', height: '11px', borderRadius: '2px', background: colors[day.level], cursor: day.level > 0 ? 'pointer' : 'default' }}>
              </div>
            ))}
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px', fontSize: '9px', color: '#94A3B8' }}>
        <span>1 year ago</span><span>Today</span>
      </div>
    </div>
  );
};

export default StreakCalendar;
